import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES, BONOS, PRODUCT_NAME, GUARANTEE_PLACEHOLDER, PAYMENT_PLACEHOLDER } from './salesData';
import { BUNDLE_IMAGE_URL } from '../utils/headMeta';
export function OfferSection() {
  return <section id="comprar" className="bg-sand pb-16 pt-12 sm:py-16" data-id="element-152" data-mp="idzwh5bsfa4s">
      <div className="mx-auto max-w-5xl px-5" data-id="element-153" data-mp="metkdyp8coxo">
        <div className="text-center" data-id="element-154" data-mp="mdihe13lzl7m">
          <SectionTag className="bg-white" data-id="element-155" data-mp="mgo79ik2ar4e">Todo lo que recibes</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[20ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[28ch] sm:text-[2.3rem]" data-id="element-156" data-mp="refx8715c35y">
            Los 6 tomos y los 4 bonos, en un <span className="mark-yellow" data-id="element-157" data-mp="2t742sn19j2ow">solo pago</span>.
          </h2>
        </div>

        <div className="mt-7 overflow-hidden rounded-[2rem] border border-stone bg-white shadow-[0_40px_80px_-50px_rgba(25,23,19,0.5)]" data-id="element-158" data-mp="2y4w6sff6mf9g">
          <div className="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]" data-id="element-159" data-mp="xws6a3nfw0wo">
            <div className="flex items-center justify-center bg-cream px-5 py-7 sm:p-10" data-id="element-160" data-mp="xup6wt0ecvfa">
              <img src={BUNDLE_IMAGE_URL} alt="Los 6 tomos de la colección 500+ Recetas Keto + Sin Gluten" loading="lazy" decoding="async" width={1209} height={1298} className="h-auto w-full max-w-[320px] object-contain drop-shadow-[0_26px_34px_rgba(25,23,19,0.18)] sm:max-w-[420px]" data-id="element-161" data-mp="sxyssb85k9wi" />
            </div>

            <div className="p-6 sm:p-9" data-id="element-162" data-mp="17mljf938co31">
              <p className="font-display text-[1.3rem] font-extrabold uppercase leading-tight tracking-tight text-charcoal sm:text-[1.7rem]" data-id="element-163" data-mp="17ljwa68xwb4y">
                {PRODUCT_NAME}
              </p>

              <p className="mt-4 font-display text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-164" data-mp="3sckjyxhy3uvm">
                La colección
              </p>
              <ul className="mt-2.5 space-y-1.5" data-id="element-165" data-mp="2nok1sum6dnd">
                {OFFER_INCLUDES.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.85rem] leading-snug text-charcoal/85" data-id="element-166" data-mp="3ktbcxawww89q">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-coral" aria-hidden strokeWidth={3} data-id="element-167" data-mp="3owzlnwxa59wk" />
                    {item}
                  </li>)}
              </ul>

              <p className="mt-5 font-display text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-168" data-mp="316wvxngu8g14">
                + Los 4 bonos de regalo
              </p>
              <ul className="mt-2.5 space-y-1.5" data-id="element-169" data-mp="2s4dyjivtmvm9">
                {BONOS.map(bono => <li key={bono.num} className="flex gap-2.5 font-sans text-[0.85rem] font-medium leading-snug text-charcoal/85" data-id="element-170" data-mp="2x4091kk9lxrd">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-coral" aria-hidden strokeWidth={3} data-id="element-171" data-mp="28jdn90rprxv0" />
                    {bono.name}
                  </li>)}
              </ul>

              <PriceBlock className="mt-7" size="lg" data-id="element-172" data-mp="2wgt1u82ipfz3" />

              <div className="mt-5 flex justify-center" data-id="element-173" data-mp="2wf8b6tjbqh6i">
                <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-174" data-mp="2ri854imh5efe" />
              </div>

              <p className="mt-3.5 text-center font-sans text-[0.76rem] font-semibold text-taupe" data-id="element-175" data-mp="366cpdr16dy0a">
                Compra única · Acceso digital inmediato
              </p>
              <p className="mt-1.5 text-center font-sans text-[0.72rem] text-taupe/80" data-id="element-176" data-mp="319m7cy5t8sc8">
                🔒 Pago seguro · {PAYMENT_PLACEHOLDER}
              </p>

              <div className="mt-5 flex items-start gap-2.5 rounded-xl border border-stone bg-cream px-3.5 py-3" data-id="element-177" data-mp="3a993p5jon7yf">
                <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" aria-hidden strokeWidth={2.5} data-id="element-178" data-mp="18iikz9dczn9t" />
                <p className="font-sans text-[0.78rem] leading-snug text-taupe" data-id="element-179" data-mp="1ia4u9064zc9x">
                  <span className="font-bold text-charcoal" data-id="element-180" data-mp="1maors4umghwl">Garantía:</span>{' '}
                  {GUARANTEE_PLACEHOLDER}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}